import { data } from '../../svg/AutomationCircle/data';
import { makeIcon } from '../makeIcon';

export const AutomationCircle = makeIcon(data, 'automation_circle', 'AutomationCircle');

export default AutomationCircle;
